import * as moment from 'moment';
import { Directive, EventEmitter, HostListener, Optional, Output } from '@angular/core';
import { KEY_CODE } from '@app/shared/constants/key-code.const';
import { NgControl } from '@angular/forms';
import { hasValue } from '@app/shared/comparison-helpers.service';

const rightArrowEvent = new KeyboardEvent('keydown', {
  keyCode: 39,
  key: 'ArrowRight'
} as KeyboardEventInit);

const leftArrowEvent = new KeyboardEvent('keydown', {
  keyCode: 37,
  key: 'ArrowLeft'
} as KeyboardEventInit);

const generalDateFieldKeys = [
  'Backspace', // BACKSPACE
  'Tab', // TAB
  'Enter', // ENTER
  'Escape', // ESCAPE
  'Delete', // DELETE
  '/' // FORWARD SLASH
];

@Directive({
  selector: '[acsDatePickerEvtHandler]'
})
export class DatepickerHelperDirective {
  @Output() keypressDateChange: EventEmitter<moment.Moment> = new EventEmitter();

  constructor(@Optional() private baseControl: NgControl) {}

  @HostListener('opened')
  pickerOpened(): void {
    const calendarContent = document.getElementsByClassName('mat-calendar-content')[0];
    if (hasValue(calendarContent)) {
      calendarContent.addEventListener('keypress', (keypress: KeyboardEvent) => {
        const calendarBody = document.getElementsByClassName('mat-calendar-body')[0];
        if (hasValue(calendarBody)) {
          if (keypress.code === 'NumpadAdd') {
            calendarBody.dispatchEvent(rightArrowEvent);
          } else if (keypress.code === 'NumpadSubtract') {
            calendarBody.dispatchEvent(leftArrowEvent);
          }
        }
      });
    }
  }

  @HostListener('keydown', ['$event', '$event.target.value'])
  inputKeyPressed(event: KeyboardEvent, currentInputValue: any): void {
    // allow predefined keys
    if (
      generalDateFieldKeys.indexOf(event.key) !== -1 ||
      ((event.ctrlKey || event.metaKey) &&
        (event.key === KEY_CODE.A ||
          event.key === KEY_CODE.C ||
          event.key === KEY_CODE.V ||
          event.key === KEY_CODE.X ||
          event.key === KEY_CODE.Z)) ||
      event.key === KEY_CODE.RIGHT_ARROW ||
      event.key === KEY_CODE.LEFT_ARROW ||
      event.key === KEY_CODE.HOME ||
      event.key === KEY_CODE.END ||
      parseInt(event.key, 10) ||
      parseInt(event.key, 10) === 0
    ) {
      return;
    }

    const isPlusMinusKey = event.code === 'NumpadAdd' || event.code === 'NumpadSubtract';

    if (hasValue(this.baseControl) && isPlusMinusKey) {
      event.preventDefault();

      if (!hasValue(currentInputValue) || currentInputValue === '') {
        this.baseControl.control.setValue(moment());
      } else {
        const valueAsMoment = moment(currentInputValue, 'L');
        if (event.code === 'NumpadAdd') {
          const nextDate = valueAsMoment.add(1, 'day');
          this.baseControl.control.setValue(nextDate);
          this.keypressDateChange.emit(nextDate);
        } else if (event.code === 'NumpadSubtract') {
          const previousDate = valueAsMoment.subtract(1, 'day');
          this.baseControl.control.setValue(previousDate);
          this.keypressDateChange.emit(previousDate);
        }
      }

      this.baseControl.control.markAsDirty();
    } else {
      event.preventDefault();
    }
  }
}
